import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import OurCoursesall from '../component/OurCoursesall';

export default function Courses() {
  return (
    <div>
      <Navbar />
      <OurCoursesall />
      <Footer />
    </div>
  );
}
